import React, { Component } from "react";
import { Form, Button, Col, Row, Icon, Tooltip, Drawer, Modal, message, Divider, Collapse } from "antd";
import axios from "axios";
import Colors from '../utils/Colors';
import InputForm from "./InputForm";
import { resolveImageUrl } from '../utils/Storage';
// import { getUsuario } from "../utils/LoginManager";
import moment from "moment-timezone";
import numeral from "numeral";


const { Item: ItemForm } = Form;
const Panel = Collapse.Panel;

export const OPCOES_COMBO_MODULO = [
    { key: '1', label: 'PLANO ADVANCED' },
    { key: '2', label: 'PLANO PRO' },
    { key: '3', label: 'PLANO BASIC' },
    { key: '4', label: 'NOTAS FISCAIS' },
]

export const OPCOES_COMBO_PERIODO = [
    { key: '0', label: 'Selecione um Período' },
    { key: '1', label: '1 MÊS' },
    { key: '12', label: '12 MESES' },
]

export const OPCOES_COMBO_PAGTO1 = [
    { key: '0', label: 'Selecione uma Forma de Pagamento' },
    { key: '1', label: 'PIX / BOLETO BANCÁRIO' },
    { key: '2', label: 'CARTÃO DE CRÉDITO' },
]

export const OPCOES_COMBO_PAGTO2 = [
    { key: '0', label: 'Selecione uma Forma de Pagamento' },
    { key: '2', label: 'CARTÃO DE CRÉDITO' },
]


class AssinaturaDrawer extends Component {
    state = {
        visible: false,
        carregouDados: false,
        registro: {
            periodo: { key: '0', label: 'Selecione um Período' },
            pagto: { key: '0', label: 'Selecione uma Forma de Pagamento' },
            flag_renova: 1,
        },
        periodo: { key: '0', label: 'Selecione um Período' },
        pagto: { key: '0', label: 'Selecione uma Forma de Pagamento' },
        flag_renova: 1,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if ((this.state.visible) && (!this.state.carregouDados)) {
            this.setState({
                carregouDados: true,
                registro: {
                    periodo: { key: '0', label: 'Selecione um Período' },
                    pagto: { key: '0', label: 'Selecione uma Forma de Pagamento' },
                    flag_renova: 1,
                },
            }, () => {
                this.onBuscaParametros()
            });

        }
    }

    componentDidMount() {
        // const usuario = getUsuario();
        // this.setState({
        //     usuario,
        // });
    }

    showDrawer = () => {
        this.setState({
            visible: true,
            carregouDados: false,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
            carregouDados: false,
            registro: {
                periodo: { key: '0', label: 'Selecione um Período' },
                pagto: { key: '0', label: 'Selecione uma Forma de Pagamento' },
                flag_renova: 1,
            },
        });
    };

    onSalvarClick = () => {

        if ((!this.state.registro.emp_nome) || (this.state.registro.emp_nome === '')) {
            Modal.warning({ title: 'Aviso!', content: 'Nome da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }
        if ((!this.state.registro.emp_cpf_cnpj) || (this.state.registro.emp_cpf_cnpj === '')) {
            Modal.warning({ title: 'Aviso!', content: 'CPF/CNPJ da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }
        if ((!this.state.registro.emp_email) || (this.state.registro.emp_email === '')) {
            Modal.warning({ title: 'Aviso!', content: 'Email da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }
        if ((!this.state.registro.emp_endereco) || (this.state.registro.emp_endereco === '')) {
            Modal.warning({ title: 'Aviso!', content: 'Endereço da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }
        if ((!this.state.registro.emp_numero) || (this.state.registro.emp_numero === '')) {
            Modal.warning({ title: 'Aviso!', content: 'Número do Endereço da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }
        if ((!this.state.registro.emp_bairro) || (this.state.registro.emp_bairro === '')) {
            Modal.warning({ title: 'Aviso!', content: 'Bairro do endereço da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }
        if ((!this.state.registro.emp_cep) || (this.state.registro.emp_cep === '')) {
            Modal.warning({ title: 'Aviso!', content: 'CEP da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }
        if (this.state.registro.emp_cep.length < 8) {
            Modal.warning({ title: 'Aviso!', content: 'CEP da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }
        if ((!this.state.registro.emp_fone1) || (this.state.registro.emp_fone1 === '')) {
            Modal.warning({ title: 'Aviso!', content: 'Telefone da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }
        if (this.state.registro.emp_fone1.length < 11) {
            Modal.warning({ title: 'Aviso!', content: 'Telefone Celular da empresa não cadastrado. Acesse o menu Configurações/Empresa para completar o cadastro.', });
            return;
        }

        // if ((!this.state.periodo) || (this.state.periodo.key === '') || (this.state.periodo.key === '0')) {
        //     Modal.warning({ title: 'Aviso!', content: 'Informe o Período da Assinatura', });
        //     return;
        // }
        // if ((!this.state.pagto) || (this.state.pagto.key === '') || (this.state.pagto.key === '0')) {
        //     Modal.warning({ title: 'Aviso!', content: 'Informe a Forma de Pagamento', });
        //     return;
        // }
        // const registro = {
        //     periodo: this.state.periodo.key,
        //     pagto: this.state.pagto.key,
        //     valor: this.state.periodo.key === '1' ? parseFloat(this.state.registro.contr_valor_mensal) : ((parseInt((parseFloat(this.state.registro.contr_valor_mensal) * 10) / parseInt(this.state.periodo.key))) * 12),
        //     // renovar: this.state.flag_renova ? true : false,
        // };

        const registro = {
            periodo: 1,
            pagto: 1,
            valor: parseFloat(this.state.registro.contr_valor_mensal),
            // renovar: this.state.flag_renova ? true : false,
        };

        this.setState({ salvando: true })
        // console.log('onSalvarClick: ', registro);
        // return;
        axios
            .put('/contratos/storaAssinaturaAsaas', registro)
            .then(response => {
                this.onClose();
                this.setState({ salvando: false })
                Modal.success({ title: 'Plano Renovado', content: 'Plano de Assinatura renovado com sucesso. Você receberá uma mensagem no Email, Whtasapp e SMS com a cobrança para fazer o pagamento na data de hoje. Caso não receba, entre em contato com o suporte', okText: 'OK', })
            })
            .catch(error => {
                console.error(error.response);
                this.setState({ salvando: false })
                Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
            })
    }


    onBuscaParametros = registro => {
        this.setState({ carregando: true });
        axios.get(`/parametros/getPararametros`)
            .then(response => {
                const { data } = response;

                // console.log('onBuscaParametros: ', data);

                this.setState({
                    registro: data,
                    carregando: false,
                })
            })
            .catch(error => {
                console.error(error.response);
                this.setState({
                    carregando: false,
                })
            })
    };


    onChangePeriodo = event => {
        const value = event.target.value;
        const id = event.target.id;
        const { registro } = this.state;
        registro['pagto'] = { key: '2', label: 'CARTÃO DE CRÉDITO' };
        registro[id] = value;
        this.setState({
            [id]: value,
            pagto: { key: '2', label: 'CARTÃO DE CRÉDITO' }
        });
    };

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        const { registro } = this.state;
        registro[id] = value;
        this.setState({ [id]: value });
    };











    render() {
        const { placement, visible, salvando, pagto, periodo, flag_renova } = this.state;

        // console.log('AssinaturaDrawer.state: ', this.state);
        // console.log('AssinaturaDrawer.props: ', this.props);

        return (
            <div>
                <Button
                    htmlType="button"
                    loading={salvando}
                    onClick={this.showDrawer}
                    className="btn-fechar"
                >
                    Meu Plano
                </Button>

                <Drawer
                    // title="Detalhes do Plano"
                    placement={placement}
                    closable={false}
                    onClose={this.onClose}
                    visible={visible}
                    key={placement}
                    width={"30%"}
                >
                    <Tooltip title="Fechar">
                        <span style={{ fontSize: 20, color: Colors.accentLight, float: "right", marginTop: -70, marginRight: 20, cursor: 'pointer' }} onClick={this.onClose}>
                            <Icon type="close" />
                        </span>
                    </Tooltip>


                    <div className="card-container" style={{ minHeight: 0 }}>
                        <Row>
                            <Col xs={24} style={{ textAlign: 'center', marginBottom: 20 }}>
                                <span style={{ fontSize: 30, fontWeight: 'bold' }}>Detalhes do Plano</span>
                            </Col>

                            <Divider />

                            <div>
                                <Col xs={12}>
                                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>Tipo do Plano: </span>
                                </Col>
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                    <span style={{ fontSize: 20 }}>
                                        {this.state.registro.emp_plano === 1 ? 'PLANO ADVANCED' : this.state.registro.emp_plano === 2 ? 'PLANO PRO' : this.state.registro.emp_plano === 3 ? 'PLANO BASIC' : this.state.registro.emp_plano === 4 ? 'NOTAS FISCAIS' : 'SEM PLANO'}
                                    </span>
                                </Col>
                            </div>

                            <Divider />

                            <div>
                                <Col xs={12}>
                                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>Status: </span>
                                </Col>
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                    {this.state.registro.contr_bloqueio === 1 ? (
                                        <span style={{ fontSize: 20, fontWeight: "bold", color: "red" }}>
                                            {'BLOQUEADO EM ' + moment(this.state.registro.contr_data_bloqueio).format('DD/MM/YYYY')}
                                        </span>
                                    )
                                        : this.state.registro.contr_situacao === 0 ? (
                                            <span style={{ fontSize: 20, fontWeight: "bold", color: "red" }}>
                                                {'CANCELADO EM ' + moment(this.state.registro.contr_data_cancelamento).format('DD/MM/YYYY')}
                                            </span>
                                        )
                                            : (this.state.registro.contr_data_contratado === '' || this.state.registro.contr_data_contratado === null) ? (
                                                <span>
                                                    <Row style={{ fontSize: 20, fontWeight: "bold", color: "red" }}>
                                                        PERÍODO DE TESTES
                                                    </Row>
                                                    <Row style={{ fontSize: 20, fontWeight: "bold", color: "red" }}>
                                                        {this.state.registro.contr_data_emissao ? 'VENCE EM ' + (moment(this.state.registro.contr_data_emissao).add(15, "d").format('DD/MM/YYYY')) : ''}
                                                    </Row>
                                                </span>
                                            )
                                                : !this.state.registro.contr_situacao ? (
                                                    <span>
                                                        <Row style={{ fontSize: 20, fontWeight: "bold", color: "red" }}>
                                                            INATIVO
                                                        </Row>
                                                    </span>
                                                )
                                                    : (
                                                        <span>
                                                            <Row style={{ fontSize: 20, fontWeight: "bold", color: "rgba(5, 121, 18, 0.45)" }}>
                                                                ATIVO
                                                            </Row>
                                                        </span>
                                                    )
                                    }
                                </Col>
                            </div>

                            <Divider />

                            <div>
                                <Col xs={12}>
                                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>Data do Cadastro: </span>
                                </Col>
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                    <span style={{ fontSize: 20 }}>
                                        {this.state.registro.contr_data_emissao ? moment(this.state.registro.contr_data_emissao).format('DD/MM/YYYY') : ''}
                                    </span>
                                </Col>
                            </div>

                            <Divider />

                            <div>
                                <Col xs={12}>
                                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>Data da Assinatura: </span>
                                </Col>
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                    <span style={{ fontSize: 20 }}>
                                        {this.state.registro.contr_data_contratado ? moment(this.state.registro.contr_data_contratado).format('DD/MM/YYYY') : 'NÃO ASSINADO'}
                                    </span>
                                </Col>
                            </div>


                            <Divider />

                            {this.props.mensalidade && this.props.mensalidade.situacao_parcela ? (
                                <div>
                                    <Col xs={12}>
                                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>{this.props.mensalidade.situacao_parcela === 'PAGO' ? 'Data Pagamento Mensalidade' : 'Data Vencimento Mensalidade'}</span>
                                    </Col>
                                    <Col xs={12} style={{ textAlign: 'right' }}>
                                        <span style={{ fontSize: 20 }}>
                                            {this.props.mensalidade.situacao_parcela === 'PAGO' ? moment(this.props.mensalidade.pgto_data).format('DD/MM/YYYY') : moment(this.props.mensalidade.tparc_data_parcela).format('DD/MM/YYYY')}
                                        </span>
                                    </Col>
                                    <Divider />
                                </div>
                            ) : null}


                            {this.state.registro.contr_data_bloqueio ? (
                                <div>
                                    <Col xs={12}>
                                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>Data do Bloqueio: </span>
                                    </Col>
                                    <Col xs={12} style={{ textAlign: 'right' }}>
                                        <span style={{ fontSize: 20 }}>
                                            {moment(this.state.registro.contr_data_bloqueio).format('DD/MM/YYYY')}
                                        </span>
                                    </Col>
                                    <Divider />
                                </div>
                            ) : null}


                            {this.state.registro.contr_data_cancelamento ? (
                                <div>
                                    <Col xs={12}>
                                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>Data do Cancelamento: </span>
                                    </Col>
                                    <Col xs={12} style={{ textAlign: 'right' }}>
                                        <span style={{ fontSize: 20 }}>
                                            {moment(this.state.registro.contr_data_cancelamento).format('DD/MM/YYYY')}
                                        </span>
                                    </Col>
                                    <Divider />
                                </div>
                            ) : null}


                            <div>
                                <Col xs={18}>
                                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>Quantidade de Usuários: </span>
                                </Col>
                                <Col xs={6} style={{ textAlign: 'right' }}>
                                    <span style={{ fontSize: 20 }}>
                                        {this.state.registro.par_qtde_usuarios}
                                    </span>
                                </Col>
                            </div>

                            <Divider />

                            <div>
                                <Col xs={18}>
                                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>Quantidade de Emitentes de NF: </span>
                                </Col>
                                <Col xs={6} style={{ textAlign: 'right' }}>
                                    <span style={{ fontSize: 20 }}>
                                        {this.state.registro.par_qtde_emitentes_nf}
                                    </span>
                                </Col>
                            </div>

                            <Divider />

                            <div>
                                <Col xs={12}>
                                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>Valor Implantação: </span>
                                </Col>
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                    <span style={{ fontSize: 20 }}>
                                        {'R$ ' + numeral(parseFloat(this.state.registro.contr_valor_inicial)).format('0,000.00')}
                                    </span>
                                </Col>
                            </div>

                            <Divider />

                            <div>
                                <Col xs={12}>
                                    <span style={{ fontSize: 20, fontWeight: 'bold' }}>Valor Mensalidade: </span>
                                </Col>
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                    <span style={{ fontSize: 20 }}>
                                        {'R$ ' + numeral(parseFloat(this.state.registro.contr_valor_mensal)).format('0,000.00')}
                                    </span>
                                </Col>
                            </div>

                            <Divider />

                            <Row style={{ textAlign: 'center', marginBottom: 30, marginTop: 30 }}>
                                <div>
                                    <div className="divider-form" />
                                    {this.state.registro.contr_data_contratado ? null : (
                                        <Button
                                            type="primary"
                                            htmlType="button"
                                            loading={salvando}
                                            onClick={this.onSalvarClick}
                                            className="btn-salvar"
                                        >
                                            Assinar Plano
                                        </Button>
                                    )}

                                    <Button
                                        htmlType="button"
                                        onClick={this.onClose}
                                        className="btn-fechar"
                                    >
                                        Fechar
                                    </Button>
                                </div>
                            </Row>

                            {/* {this.props && this.props.mensalidade && this.props.mensalidade.situacao_parcela && this.props.mensalidade.situacao_parcela === 'ABERTO' ? null : (

                                <Row style={{ marginTop: 40 }}>
                                    <Collapse>
                                        <Panel header={<span style={{ fontSize: 20, fontWeight: 'bold', marginTop: -10 }}>Renovar Assinatura</span>} key="1">

                                            <Row>
                                                <Col xs={24} style={{ marginTop: 0 }}>
                                                    <span>Período Assinatura</span>
                                                    <InputForm
                                                        type="select"
                                                        id="periodo"
                                                        ref="periodo"
                                                        value={periodo}
                                                        placeholder="Selecione"
                                                        onChange={this.onChangePeriodo}
                                                        data={OPCOES_COMBO_PERIODO}
                                                        validator={value => Boolean(value)}
                                                        style={{ width: "100%" }}
                                                    />
                                                </Col>

                                                <Col xs={24} style={{ marginTop: 0 }}>
                                                    <span>Forma Pagamento</span>
                                                    <InputForm
                                                        type="select"
                                                        id="pagto"
                                                        ref="pagto"
                                                        value={pagto}
                                                        placeholder="Selecione"
                                                        onChange={this.onChange}
                                                        data={OPCOES_COMBO_PAGTO1}
                                                        validator={value => Boolean(value)}
                                                        style={{ width: "100%" }}
                                                    />
                                                </Col>

                                                <Col xs={24} style={{ marginTop: 0 }}>
                                                    <Col xs={12}>
                                                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>Valor das Mensalidade: </span>
                                                    </Col>
                                                    <Col xs={12} style={{ textAlign: 'right' }}>
                                                        {this.state.periodo.key === '1' ? (
                                                            <span style={{ fontSize: 20 }}>
                                                                {'R$ ' + numeral(parseFloat(this.state.registro.contr_valor_mensal)).format('0,000.00')}
                                                            </span>
                                                        ) : (
                                                            <span style={{ fontSize: 20 }}>
                                                                {'R$ ' + numeral(parseInt((parseFloat(this.state.registro.contr_valor_mensal) * 10) / parseInt(this.state.periodo.key))).format('0,000.00')}
                                                            </span>
                                                        )
                                                        }
                                                    </Col>
                                                </Col>
                                                <Divider />

                                                <Col xs={24} style={{ marginTop: 0 }}>
                                                    <Col xs={12}>
                                                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>Total Pagamento: </span>
                                                    </Col>
                                                    <Col xs={12} style={{ textAlign: 'right' }}>
                                                        {this.state.periodo.key === '1' ? (
                                                            <span style={{ fontSize: 20, fontWeight: 'bold' }}>
                                                                {'R$ ' + numeral(parseFloat(this.state.registro.contr_valor_mensal)).format('0,000.00')}
                                                            </span>
                                                        ) : (
                                                            <span style={{ fontSize: 20, fontWeight: 'bold' }}>
                                                                {'R$ ' + numeral((parseInt((parseFloat(this.state.registro.contr_valor_mensal) * 10) / parseInt(this.state.periodo.key))) * 12).format('0,000.00')}
                                                            </span>
                                                        )
                                                        }
                                                    </Col>
                                                </Col>
                                                <Divider />

                                            </Row>
                                            <Row style={{ textAlign: 'center', marginBottom: 30, marginTop: 30 }}>
                                                <div className="divider-form" />
                                                <Button
                                                    type="primary"
                                                    htmlType="button"
                                                    loading={salvando}
                                                    onClick={this.onSalvarClick}
                                                    className="btn-salvar"
                                                >
                                                    Assinar Plano
                                                </Button>
                                            </Row>

                                        </Panel>

                                    </Collapse>
                                </Row>
                            )} */}
                        </Row>
                    </div>

                    {/* <div>
                        <div className="divider-form" />

                        <Button
                            htmlType="button"
                            onClick={this.onClose}
                            className="btn-fechar"
                        >
                            Fechar
                        </Button>
                    </div> */}

                </Drawer>
            </div >
        );
    }
}

export default AssinaturaDrawer;



// WEBPACK FOOTER //
// ./src/components/AssinaturaDrawer.js